module.exports = {"pathContext":{"name":"DoseRangeStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"ABOVE"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"BELOW"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"WITHIN"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-dose-range-status.json
// module id = 1237
// module chunks = 183345800754294